const TOKEN_STORAGE_KEY = 'dash_auth_token'

function base64UrlDecode(input) {
  const str = String(input || '')
    .replace(/-/g, '+')
    .replace(/_/g, '/')
  const pad = str.length % 4
  const padded = pad ? str + '='.repeat(4 - pad) : str
  try {
    // atob lida com latin1; este decode garante UTF-8 quando necessário
    const binary = atob(padded)
    const bytes = Array.prototype.map.call(binary, (c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join('')
    return decodeURIComponent(bytes)
  } catch (e) {
    return ''
  }
}

export function decodeJwtPayload(token) {
  const t = String(token || '').trim()
  if (!t) return null
  const parts = t.split('.')
  if (parts.length < 2) return null
  const json = base64UrlDecode(parts[1])
  if (!json) return null
  try {
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

export function getAuthToken() {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function setAuthToken(token) {
  const t = String(token || '').trim()
  if (!t) return
  try {
    localStorage.setItem(TOKEN_STORAGE_KEY, t)
  } catch (e) {
    // ignore
  }
}

export function clearAuthToken() {
  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}

export function getUserPermissions(token) {
  const payload = decodeJwtPayload(token || getAuthToken())
  const perms = payload && Array.isArray(payload.permissoes) ? payload.permissoes : []
  return perms
    .map((p) => Number(p))
    .filter((p) => !Number.isNaN(p))
}

export function hasPermission(requiredPermission, token) {
  const req = Number(requiredPermission)
  if (Number.isNaN(req)) return true
  const perms = getUserPermissions(token)
  return perms.indexOf(req) !== -1
}

